export * from './delete-kunde.component';
export * from './delete-kunde.component.module';